// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__OjjHo","inputDescription":"styles_inputDescription__7iQbS"};